import React, { useRef } from 'react'
import { Button, Form, useToaster } from 'react-angle-dashboard-components'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { Paths } from '../../routes/paths'
import styled from 'styled-components'
import { authService } from '../../services'
import { FormWrapper } from '../style'
import { LoginLayout } from '../Login/LoginLayout'

export const ValidationError = styled.p`
  color: var(--danger);
  margin-top: 5px;
`

interface ChangePasswordProps {
  location: {
    state?: {
      oldPassword: string
    }
  }
}

export const ChangePassword: React.FC<ChangePasswordProps> = (
  props: ChangePasswordProps
) => {
  const history = useHistory()
  const toaster = useToaster()

  const oldPassword = props.location?.state?.oldPassword

  const { handleSubmit, control, formState, watch } = useForm({
    mode: 'onChange',
    defaultValues: {
      password: '',
      confirmPassword: '',
      oldPassword: ''
    }
  })

  const { errors } = formState

  const password = useRef({})
  password.current = watch('password', '')

  const handleContinue = handleSubmit(async (data) => {
    try {
      await authService.changePassword({
        old_password: oldPassword ?? data.oldPassword,
        new_password: data.password
      })

      history.push(Paths.home)
    } catch (e: any) {
      toaster.show({
        message: e.message,
        type: 'danger'
      })
    }
  })

  const missingPassword =
    errors?.password?.type === 'required' &&
    formState.isSubmitted &&
    !formState.isSubmitting

  const missingConfirmPassword =
    errors?.confirmPassword?.type === 'required' &&
    formState.isSubmitted &&
    !formState.isSubmitting

  return (
    <LoginLayout>
      <div className="d-flex align-items-center flex-column px-3">
        <div>
          <p className="fs-32">
            <span className="d-block text-center">
              Please choose a new password for your
            </span>
            <span className="d-block text-center mb-10">
              Angle Broker account
            </span>
          </p>
        </div>
        <FormWrapper>
          <Form>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Controller
                name="password"
                rules={{ required: true, minLength: 8 }}
                control={control}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    type="password"
                    placeholder="Password"
                    className="bg-white"
                    isInvalid={missingPassword}
                  />
                )}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Confirm Password</Form.Label>
              <Controller
                name="confirmPassword"
                rules={{
                  required: true,
                  minLength: 8,
                  validate: (value: string) => value === password.current
                }}
                control={control}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    type="password"
                    placeholder="Confirm password"
                    className="bg-white"
                    isInvalid={missingConfirmPassword}
                  />
                )}
              />
            </Form.Group>
            {formState.isSubmitted && errors.password?.type === 'minLength' && (
              <ValidationError>
                Password must be 8 characters or more.
              </ValidationError>
            )}
            {formState.isSubmitted &&
              errors.confirmPassword?.type === 'validate' && (
                <ValidationError>Passwords do not match.</ValidationError>
              )}
          </Form>
          <Button
            disabled={formState.isSubmitting}
            className="w-100"
            onClick={handleContinue}
          >
            Continue
          </Button>
        </FormWrapper>
      </div>
    </LoginLayout>
  )
}
